export default __webpack_public_path__ + "static/media/profile-img.d8437cde.png";